import { render, staticRenderFns } from "./ClaimConsumers.vue?vue&type=template&id=574b9a4e&scoped=true&"
import script from "./ClaimConsumers.vue?vue&type=script&lang=js&"
export * from "./ClaimConsumers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574b9a4e",
  null
  
)

export default component.exports